import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { TableLayout } from "../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
class TableUnidadesTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreUnidadeOrcamentaria(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  render() {
    var tableHeaders = ["Código", "Nome", "Tipo de administração", "Ações"]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />

        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar unidade orçamentária"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">{row.cod_uni_orc}</td>
                    <td className="col-md-6">{row.uni_orc}</td>
                    {row.tipo_admin === "D" && (
                      <td className="col-sm-2">Direta</td>
                    )}
                    {row.tipo_admin !== "D" && (
                      <td className="col-sm-2">Indireta</td>
                    )}
                    <td className="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover unidade orçamentária"
                        onClick={() => this.restore(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableUnidadesTrash)



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/TableUnidadesTrash.js